import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Skill } from '@/apis/skills/types/skillsApi';
import { millwrightSkillsFromApiAdapter } from '@/apis/skills/adapters/skillFromApiAdapter';
import { PaginatedResponse } from '@/types';
import { prepareHeadersWithAuthorization as prepareHeaders } from '@/apis/headers';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export interface SkillsByMillwrightIdParams {
  empId: number;
}

export const skillsApi = createApi({
  reducerPath: 'skillsApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL, prepareHeaders }),
  endpoints: (builder) => ({
    getSkillsByMillwrightId: builder.query<
      PaginatedResponse<Skill>,
      SkillsByMillwrightIdParams
    >({
      query: ({ empId }) => ({
        url: `/skills/${empId}`,
      }),
      transformResponse: millwrightSkillsFromApiAdapter,
    }),
  }),
});

export const { useGetSkillsByMillwrightIdQuery } = skillsApi;
